import { call, put } from "redux-saga/effects";
import devisService from "../services/devisService";
import { createModule } from "saga-slice";
import { get } from "lodash";
import commandeService from "../services/commandeService";

const initialState = {
    list: [],
    newDevisNumber: null,
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 6, // Size of each page
};

const commandeSlice = createModule({
    name: 'commande',
    initialState,
    reducers: {
        generatePdfRequest: (state) => {
            state.loading = true;
        },
        list: (state) => {
            state.loading = true;
        },
        validerCommande: (state) => {
            state.loading = true;
        },

        add: (state) => {
            state.loading = true;
        },
        delete: (state) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.list = payload.body;
            
        },
        finishFetching: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action.payload || "An error occurred";
        },
        generatePdfSuccess: (state) => {
            state.loading = false;
        },
        generatePdfFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        deleteSuccess: (state, action) => {
            state.loading = false;
            state.devis = state.devis.filter(d => d.id !== action.id);
        },
        deleteFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        update: (state) => {
            state.loading = true;
        },

    },
    sagas: (A) => ({
        *[A.list]({ payload }) {
            try {
                console.log(payload);
                const data = yield call(commandeService.list, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if(payload.onSuccess) {
                    payload.onSuccess();
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },

        *[A.validerCommande]({ payload }) {
            try {
                console.log(payload);
                const data = yield call(commandeService.validerCommande, payload.id);
                yield put(A.finishFetching());
                if (payload.onSuccess) {
                    payload.onSuccess();
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        
        *[A.add]({ payload }) {
            try {
                const data = yield call(commandeService.add, payload.data);
                yield put(A.finishFetching());
                payload.onSuccess(data);
                //yield put(A.generatePdfRequest(data.data.body)); // Dispatch the action to generate the PDF after invoice creation
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.generatePdfRequest]({ payload }) {
            try {
                const pdfData = yield call(commandeService.generatePdf, payload);
                const blob = new Blob([pdfData], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank'); // Open the PDF in a new window
                yield put(A.generatePdfSuccess());
            } catch (error) {
                yield put(A.generatePdfFailure(error.message));
            }
        },
        *[A.delete]({ payload }) {
            try {
                yield call(commandeService.delete, payload.id);
                yield put(A.deleteSuccess(payload));
                payload.onSuccess();
            } catch (e) {
                yield put(A.deleteFailure(e.message));
            }
        },
        
        *[A.update]({ payload }) {
            try {
                yield call(commandeService.update, payload.id, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
    }),

});

export default commandeSlice;
export const commandeActions = commandeSlice.actions;